import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import '../styles/cv_style.css';
import {
    Header,
    Formations,
    Experiences,
    Languages,
    Technologies,
    SideBar
} from '../components/cv';

export const CV = () => {
    return (
        <Container >
            <Row>
                <Col md={4} lg={4} xl={4} className="right__side">
                    <SideBar>
                        <Technologies />
                        <Languages />
                    </SideBar>
                </Col>
                <Col md={8} lg={8} xl={8} className="left__side">
                    <Header />
                    <Formations />
                    <Experiences />
                </Col>
            </Row>
        </Container>
    )
}